
const ViewApi = [
    {
        img:"/Images/viewers-disney.png",
        video:"videos/1564674844-disney.mp4",
        
    },
    {
        img:"/Images/viewers-marvel.png",
        video:"videos/1564676115-marvel.mp4",
    },
    {
        img:"/Images/viewers-national.png",
        video:"videos/1564676296-national-geographic.mp4",
    },
    {
        img:"/Images/viewers-pixar.png",
        video:"videos/1564676714-pixar.mp4",
    },
    {
        img:"/Images/viewers-starwars.png",
        video:"videos/1608229455-star-wars.mp4",
    },
]

export default ViewApi;